import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from '@/config/azureAdConfig';

let msalInstance = null;

/**
 * Get or create MSAL instance
 */
export function getMsalInstance() {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
  }
  return msalInstance;
}

/**
 * Initialize MSAL
 */
export async function initializeMsal() {
  const instance = getMsalInstance();
  await instance.initialize();
  return instance;
}

/**
 * Handle redirect response after login
 */
export async function handleRedirectResponse() {
  const instance = getMsalInstance();
  try {
    const response = await instance.handleRedirectPromise();
    if (response) {
      console.log('Login successful:', response.account);
    }
    return response;
  }
  catch (error) {
    console.error('Error handling redirect:', error);
    throw error;
  }
}

/**
 * Acquire access token silently
 */
export async function acquireToken() {
  const instance = getMsalInstance();
  const accounts = instance.getAllAccounts();
  
  if (accounts.length === 0) {
    return null;
  }
  
  try {
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    // console.log(response);
    return response.accessToken;
  }
  catch (error) {
    console.error('Silent token acquisition failed:', error);
    return null;
  }
}

/**
 * Login with redirect
 */
export async function login() {
  const instance = getMsalInstance();
  try {
    await instance.loginRedirect(loginRequest);
  }
  catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
}

/**
 * Logout
 */
export async function logout() {
  const instance = getMsalInstance();
  const accounts = instance.getAllAccounts();
  
  if (accounts.length > 0) {
    await instance.logoutRedirect({
      account: accounts[0]
    });
  }
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated() {
  const instance = getMsalInstance();
  const accounts = instance.getAllAccounts();
  return accounts.length > 0;
}

/**
 * Get current user account
 */
export function getCurrentUser() {
  const instance = getMsalInstance();
  const accounts = instance.getAllAccounts();
  return accounts.length > 0 ? accounts[0] : null;
}